<template>
  <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="home-donations app-bg-gradient">
      <div class="stars-bg"></div>
      <div class="payment-failed">
        <Languages class="languages" v-bind:settings="true"></Languages>
        <Timer v-if='timerStart' :setTime="setTime"></Timer>
        <div class="mosque-name">{{user.data.name}}</div>
        <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
          <div class="transaction-info">
            <div>
              <em>{{"Communication with the PDQ has failed and payment may or may not have been taken. Please manually check if the transaction was successful on the PDQ." | translate}}</em>
              <div class="flex">
                <h3>{{"Is transaction successful?" | translate}}</h3>
              </div>
              <div class="flex btns-sec">
                <div class="btn-bg1 yes">
                  <div class="btn-bg2">
                    <button class="cursor login" @click="yes">{{"Yes" | translate}}</button>
                  </div>
                </div>
                <div class="btn-bg1">
                  <div class="btn-bg2">
                    <button class="cursor login" @click="no">{{"No" | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Timer from './timer.vue'
import Languages from './Languages.vue'

export default {
  data () {
    return {
      setTime: 1,
      timerStart: true,
      failedReason: null,
      paymentId: null,
      tid: null
    }
  },
  computed: {
    ...mapGetters([
      'terminalNotificationStatus',
      'token',
      'user'
    ]),
    errorMessage () {
      return `Transaction has been faild with status "${this.failedReason}"`
    }
  },
  methods: {
    ...mapActions([
      'resetTerminalNotificationStatus',
      'resetEmailStatus',
      'updatePaymentRequestStatus',
      'changeLoadingStatus'
    ]),
    yes () {
      this.updatePaymentRequestStatus({id: this.paymentId, status: 'SUCCESSFUL'}).then((res) => {
        this.$router.push({path: `/${this.tid}/thanks-giving/${this.donationType}/${this.donationAmount}/${this.paymentId}`})
      })
      .catch(err => {
        console.log(err)
      })
    },
    no () {
      this.updatePaymentRequestStatus({id: this.paymentId, status: 'FAILED'}).then((res) => {
        this.$router.push({path: `/${this.tid}/payment-failed/${this.terminalNotificationStatus}/${this.donationType}/${this.donationAmount}/${this.paymentId}`})
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
  components: {
    Timer,
    Languages
  },
  mounted: function () {
    this.resetTerminalNotificationStatus()
    this.setTime = 1
    this.failedReason = this.$route.params.failedReason
    this.donationAmount = this.$route.params.donateAmount
    this.donationType = this.$route.params.donationType
    this.paymentId = this.$route.params.paymentId
    this.tid = this.$route.params.terminalId

    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-donations {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
  .mosque-name {
    font-size: 40px;
    color: #FFF;
    font-family: "Lato";
    font-weight: bold;
    text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
    margin-top: 61px;
    margin-bottom: 50px;
    letter-spacing: 2px;
    text-align: center;
  }
  .transaction-info {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 200px);
    flex-direction: column;
  }
  .transaction-info > div {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 5% 2%;
  }
  .transaction-info > div em {
    font-size: 18px;
    color: #880913;
    font-weight: 600;
    letter-spacing: 2px;
    line-height: 40px;
  }
  .transaction-info > div h3 {
    font-size: 26px;
    color: #880913;
    font-weight: 600;
  }
  .btn-bg1 {
    margin-top: 25px;
  }
  .yes {
    margin-right: 30px;
  }
  .payment-failed {
    z-index: 2;
  }
  div[dir='rtl'] .yes {
    margin-right: initial;
    margin-left: 5%;
  }
.full-screen {
  background-position: 50%;
}

@media only screen and (min-width: 2000px) {
  .transaction-info > div em, .transaction-info > div h3 {
    font-size: 110px;
    margin-bottom: 10%;
    letter-spacing: 6px;
    line-height: 130px;
  }
  .transaction-info {
    height: 70vh;
  }
  .btn-bg1 {
    margin-top: 200px;
    z-index: 2;
    width: 620px !important;
    height: 200px !important;
    border-radius: 200px;
  }
  .btn-bg2 {
    width: 607px;
    height: 187px;
    border-radius: 200px;
  }
  button {
    width: 594px;
    height: 178px;
    border-radius: 200px;
    font-size: 70px;
    letter-spacing: 3px;
  }

  .btns-sec {
    width: 40vw;
  }
}

@media screen and (min-width: 1200px) and (min-height: 904px) {
  .btn-bg1 {
    width: 190px;
    height: 64px;
    min-height: 64px;
  }
  .btn-bg2 {
    width: 182px;
    height: 56px;
  }
  button.login {
    width: 180px;
    height: 54px;
    font-size: 20px;
  }
  .transaction-info {
    height: 70vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/timeout.vue